import './../../assets/styles/components/docsQuestions/DocsQuestions.scss';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { CpeDocList, DocsDataQuestions, DocsQuestionsState } from 'types/cpeDocs';

interface DocsQuestionsProps {
	documents: DocsDataQuestions[];
	onResult: (result: DocsQuestionsState[]) => void;
}

const DocsQuestions = ({ documents, onResult }: DocsQuestionsProps): JSX.Element => {
	const [documentStates, setDocumentStates] = useState<DocsQuestionsState[]>([]);

	const handleSelection = (index: number, value: boolean) => {
		const newDocumentStates = [...documentStates];
		newDocumentStates[index].selectableValue = value;
		setDocumentStates(newDocumentStates);
		onResult(newDocumentStates);
	};

	useEffect(() => {
		const mapDocs = documents.map((doc) => ({
			documentType: doc.documentType,
			selectableValue: null,
		}));

		setDocumentStates(mapDocs);
		onResult(mapDocs);
	}, []);

	return (
		<div className="questionnaire">
			<h2>Validación de Documentos</h2>
			{documents.map((doc, index) => (
				<div key={doc.documentType} className="question">
					<p>{CpeDocList[doc.documentType]}</p>
					<div className="options">
						<button
							className={documentStates[index]?.selectableValue === true ? 'button selected' : 'button'}
							onClick={() => handleSelection(index, true)}
						>
							SI
						</button>
						<button
							className={documentStates[index]?.selectableValue === false ? 'button selected' : 'button'}
							onClick={() => handleSelection(index, false)}
						>
							NO
						</button>
					</div>
				</div>
			))}
		</div>
	);
};

export default DocsQuestions;
